import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { getToken, getMessaging } from "firebase/messaging";
import { isAuthenticatedUser } from "../../utils/Auth";
import { storeAPushNotification } from "../../redux/pushNotification/pushNotificationActions";
import { onMessage } from "firebase/messaging";
import notificationSound from "../../assets/audio/good_chilling_vibe.mp3"; // put in /public or import
import FirebaseMessage from "./FirebaseMessage";

export default function FirebaseNotification() {
  const dispatch = useDispatch();
  const isAuth = isAuthenticatedUser();
  const firebaseUrl = process.env.REACT_APP_FIREBASE_URL;
  const firebaseKey = process.env.REACT_APP_FIREBASE_API_KEY;
  const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;

  const messaging = getMessaging();

  useEffect(() => {
    const requestPermission = async () => {
      try {
        // ✅ Register SW by URL, not import
        await navigator.serviceWorker.register("/firebase-messaging-sw.js");

        // Wait for SW to be ready before requesting token
        await navigator.serviceWorker.ready;

        const permission = await Notification.requestPermission();

        if (permission === "granted") {
          // Get FCM token for this device
          const token = await getToken(messaging, {
            vapidKey: vapidKey, // Replace with your Firebase VAPID key
          });

          if (token) {
            // Save the token to your backend or use it as needed

            if (isAuth) {
              const uuid = async () => {
                // generate a unique id for the browser
                let uuid = await localStorage.getItem("UUID");
                if (!uuid) {
                  uuid = Math.random().toString(36).slice(2) + Date.now();
                  localStorage.setItem("UUID", uuid);
                }
                return uuid;
              };

              const createPayload = async () => {
                const deviceId = await uuid();
                const payLoad = {
                  url: firebaseUrl,
                  server_key: firebaseKey,
                  device_token: token,
                  device_id: deviceId,
                  device_type: "web",
                  notification_type: "direct",
                  notification_agent: "firebase",
                };
                return payLoad;
              };

              const payLoad = await createPayload();

              await dispatch(storeAPushNotification({ ...payLoad }));
              // console.log("res", res);
            }
          } else {
            console.log(
              "No registration token available. Request permission to generate one."
            );
          }
        } else {
          console.log("Notification permission not granted.");
        }
      } catch (error) {
        console.error("Permission Denied", error);
      }
    };

    requestPermission();
  });

  useEffect(() => {
    // Safari 3.0+ "[object HTMLElementConstructor]"
    // var isSafari =
    //   /constructor/i.test(window.HTMLElement) ||
    //   (function (p) {
    //     return p.toString() === "[object SafariRemoteNotification]";
    //   })(
    //     !window["safari"] ||
    //       (typeof safari !== "undefined" && window["safari"].pushNotification)
    //   );

    // if (isSafari) {
    //   alert(
    //     "You will not be able to get notifications on orders while using Safari browser"
    //   );
    // }
    const setupMessaging = async () => {
      const messagingInstance = await messaging; // important!

      if (messagingInstance) {
        onMessage(messagingInstance, (payload) => {
          console.log("hitssss");
          toast(<FirebaseMessage notification={payload.notification} />);
          // Create audio element
          const audio = new Audio(notificationSound);
          audio.play().catch((err) => {
            console.warn("Autoplay blocked until user interacts:", err);
          });
          if (Notification.permission === "granted") {
            new Notification(payload.notification.title, {
              body: payload.notification.body,
              icon: payload.notification.image,
            });
          }
        });
      } else {
        console.log("🚫 Messaging not supported or failed to initialize");
      }
    };

    setupMessaging();
  });

  return null;
}
